import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=fff72b14&scoped=true"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"
import style0 from "./brand.vue?vue&type=style&index=0&id=fff72b14&prod&scoped=true&lang=css"
import style1 from "./brand.vue?vue&type=style&index=1&id=fff72b14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff72b14",
  null
  
)

export default component.exports